module.exports = __webpack_public_path__ + "static/img/bg_open_vip.6cbdc1e6.png";